'use client';

import React__default, { useState, useRef, useEffect, useMemo } from 'react';
import { PreviewImage } from './AICVReview.css.js';
import '../../_virtual/_tslib.js';
import 'react-dom';
import '../../hooks/useMakeSearchable/types.js';
import '../../Utils/constants.js';
import '../../services/resumes/types.js';
import useElementOnScreen from '../../Utils/hooks/UseElementOnScreen/index.js';

var AiCVPreviewImage = function (props) {
    var langCode = props.langCode, env = props.env;
    var baseImageUrl = env.baseImageUrl;
    var _a = useState(false), isRendered = _a[0], setIsRendered = _a[1];
    var previewImageRef = useRef(null);
    var isElementOnScreen = useElementOnScreen({
        target: previewImageRef
    })[0];
    useEffect(function () {
        if (!isElementOnScreen || isRendered) {
            return;
        }
        setIsRendered(true);
    }, [isElementOnScreen, isRendered]);
    var aiCVReviewImage = useMemo(function () {
        return "".concat(baseImageUrl, "/images/ai_cv_review_").concat(langCode, ".png");
    }, [langCode]);
    return (React__default.createElement(PreviewImage, { ref: previewImageRef }, isRendered ? (React__default.createElement("img", { src: aiCVReviewImage, alt: 'VietnamWorks AI', style: {
            objectFit: 'contain'
        } })) : null));
};

export { AiCVPreviewImage as default };
//# sourceMappingURL=AiCVPreviewImage.js.map
